import * as React from 'react';
import { SnackbarProvider } from 'notistack';
import DateFnsUtils from '@date-io/date-fns';
import Collapse from '@material-ui/core/Collapse';
import { LocalizationProvider } from '@material-ui/pickers';
import { lazy, Suspense } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import ProgressBlock from 'bizom-mui/lib/ProgressBlock';

import Login from 'screens/Login';
import NoConnection from 'components/NoConnection';
import AuthenticatedRoute from './AuthenticatedRoute';

import { SessionProvider } from 'session';
import { GTMProvider } from './contexts/GTMContext';
import { HeapProvider } from './contexts/HeapContext';
import { SnackbarContextProvider } from 'contexts/SnackbarContext';

import * as paths from 'constants/paths';
import TermsAndConditions from 'components/TermsAndConditions';
import { SentryContextProvider } from './contexts/SentryContext';

const AppShell = lazy(
  () => import(/* webpackChunkName: 'App' */ 'screens/App')
);


 
window.onload = function () {
  
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const fallbackstringToDecode =   window.location.href?.split("fcminstance=")?.[1]
  const fcmInstanceParam = urlParams.get('fcminstance') || fallbackstringToDecode;
  if(fcmInstanceParam){
    const fcmInstance = JSON.parse(decodeURIComponent(fcmInstanceParam));
    localStorage.setItem('fcmToken',fcmInstance)
  } 
}


const App = () => (
  <HeapProvider>
    <GTMProvider>
      <SentryContextProvider>
        <LocalizationProvider dateAdapter={DateFnsUtils}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            TransitionComponent={Collapse}
          >
            <SnackbarContextProvider>
              <SessionProvider>
                <Router>
                  <Route path={paths.HOME} component={NoConnection} />
                  <Switch>
                    <Route path={paths.LOGIN} component={Login} />
                    <Route
                      path={paths.TERMS_AND_CONDITIONS}
                      component={TermsAndConditions}
                    />
                    <Suspense fallback={<ProgressBlock />}>
                      <AuthenticatedRoute
                        path={paths.HOME}
                        component={(props) => <AppShell {...props} />}
                      />
                    </Suspense>
                  </Switch>
                </Router>
              </SessionProvider>
            </SnackbarContextProvider>
          </SnackbarProvider>
        </LocalizationProvider>
      </SentryContextProvider>
    </GTMProvider>
  </HeapProvider>
);

export default App;